import React, { useState } from 'react';
import ServicesOneCard from './ServicesOneCard';
import servicesOneData from './servicesOneData';

function Services1() {
    const [visibleCount, setVisibleCount] = useState(4);
    const [expanded, setExpanded] = useState(false);

    const handleToggle = () => {
        if (expanded) {
            setVisibleCount(4); // collapse
        } else {
            setVisibleCount(servicesOneData.length); // expand all
        }
        setExpanded(!expanded);
    };

    return (
      <section className="services-wrapper services-1 section-bg section-padding">
        <div className="container">
          {/* Title */}
          <div className="row">
            <div className="col-12">
              <div className="section-title-3 text-center">
                <p>Our Manufacturing</p>
                <h1>Manufacturing Capabilities</h1>
              </div>
            </div>
          </div>

          {/* Cards */}
          <div className="row">
            {servicesOneData.slice(0, visibleCount).map((item) => (
              <ServicesOneCard
                key={item.id}
                bgImg={item.bgImg}
                icon={item.icon}
                heading={item.heading}
                btnText={item.btnText}
                slug={item.slug}
              />
            ))}
          </div>

          {/* Button */}
          {servicesOneData.length > 4 && (
            <div className="text-center mt-4">
              <button
                onClick={handleToggle}
                style={{
                  padding: "10px 20px",
                  border: "none",
                  background: "#4382B7",
                  color: "#fff",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontWeight: "600",
                  marginTop: "50px",
                }}
              >
                {expanded ? "View Less" : "View More"}
              </button>
            </div>
          )}
        </div>
      </section>
    );
}

export default Services1;